var parent = require('../../es/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/assign.js
// module id = 1016
// module chunks = 0